import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { FloatFilter } from 'components/common/CustomFilters/FloatFilter/FloatFilter';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const Float = ({ isSelected, onFiltersChanged }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Float</span>
            <Controller
                render={({ field }) => (
                    <FloatFilter
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                    />
                )}
                name={'float'}
                control={control}
            />
        </div>
    ) : null;
};
